const { createApp } = Vue

const app = createApp({
  data() {
    return {
      ready: false,
      subnav: 0,
      subSubnav: 0,
      mobileNavOpen: false,
      navType: 'simple',
    }
  },
  mounted() {
    this.isHammesNav()
  },
  methods: {
    openSub(node) {
      this.closeSub()

      if (node.id !== this.subnav.id) {
        this.subSubnav = 0
      }

      this.subnav = node
    },
    toggleMobileNav() {
      this.mobileNavOpen = !this.mobileNavOpen
    },
    closeSub() {
      this.subnav = 0
      this.subSubnav = 0
    },
    isHammesNav() {
      return document.querySelector('body').classList.contains('default')
    },
  },
})

app.config.compilerOptions = {
  whitespace: 'condense',
}

app.mount('#main-nav')
